import React from 'react';
import {constant, noop} from 'lodash';

import CoachesListHeader from '/component/partial/report/CoachesListHeader';
import CoachRank from '/component/partial/report/CoachRank';
import {EligibleCSBclients} from '/component/partial/report/EligibleCSBclients';
import PeopleReportDataRenderer from '/component/partial/report/PeopleReportDataRenderer';
import ReportDataProvider from '/component/partial/report/ReportDataProvider';

import {generateOnRecordPress} from '../report.util';

import reportPayload from './reportPayload';

import {useRecordsSorting} from '/context/RecordsSort/useRecordsSorting';
interface EligibleClientSupportBonusPlusContentProps {
  loadingData: {
    total?: number;
  };
  showRecordPopover: () => void;
  recordsShowPopover: () => void;
  recordsShowRecord: () => void;
  tierName: string;
}

export const EligibleClientSupportBonusPlusContent: React.FC<
  EligibleClientSupportBonusPlusContentProps
> = ({
  loadingData = {},
  showRecordPopover = noop,
  recordsShowPopover = noop,
  recordsShowRecord = noop,
  tierName = '',
}) => {
  const {isReadyToLoad, sortParam} = useRecordsSorting({
    recordsName: reportPayload.reportName,
  });

  if (!isReadyToLoad) {
    return null;
  }

  return (
    <ReportDataProvider
      {...reportPayload}
      tierName={tierName}
      dataRenderer={PeopleReportDataRenderer}
      dataRendererProps={{
        listHeaderComponent: CoachesListHeader,
        personRoleComponent: CoachRank,
        isCSBReport: true,
        tierName: tierName,
        personInfoComponent: EligibleCSBclients,
        personIsCoach: constant(true),
        onRecordPress: generateOnRecordPress({
          showRecordPopover,
          recordsShowPopover,
          recordsShowRecord,
        }),
      }}
      loadingData={loadingData}
      reportParams={[{...sortParam.params}]}
    />
  );
};
